import SuperChat from 'ai/components/SuperChat/SuperChat';
import { withSuperChatProps } from 'ai/viewModel/superChat/withSuperChatProps';

export default withSuperChatProps(SuperChat);
